import { I4BCellType } from '../configurations/i4b-column-configuration';
import { I4bCellConcept } from '../enums/i4b-cell-concept.enum';
import { HeaderType } from '../models/i4b-column-header.model';
import { I4BButtonColumn } from './i4b-button.column';

export class I4BUsersButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.USERS,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          enableConditions: [],
          visibleConditions: [
            [
              { key: 'canUpdateUserStatus', value: true },
              { key: 'canUpdateUser', value: true }
            ]
          ],
          singleActions: [
            {
              order: 0,
              key: 'configureUser',
              label: 'IOT_DICTIONARY.CONFIGURE',
              enableConditions: [],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateUser', value: true }]]
            },
            {
              order: 1,
              key: 'enableUser',
              label: 'I18N_ADMIN.USERS.TABLE.ENABLE_USER',
              enableConditions: [[{ key: 'status', value: 'disabled' }]],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateUserStatus', value: true }]]
            },
            {
              order: 2,
              key: 'resendUserValidationLink',
              label: 'I18N_ADMIN.USERS.TABLE.RESEND_CREDENTIALS',
              enableConditions: [[{ key: 'status', value: 'pending' }], [{ key: 'isShared', value: true }]],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateUser', value: true }]]
            },
            {
              order: 3,
              key: 'disableUser',
              label: 'I18N_ADMIN.USERS.TABLE.DISABLE_USER',
              enableConditions: [
                [
                  { key: 'status', value: 'active' },
                  { key: 'status', value: 'pending' }
                ]
              ],
              disableConditions: [],
              visibleConditions: [[{ key: 'canUpdateUserStatus', value: true }]]
            }
          ]
        }
      },
      { order: 1000 }
    );
  }
}
